import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/data-table";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { columns } from "./columns";

interface TeamProps {
  data: any[];
}

export const TeamData: React.FC<TeamProps> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Organigramme (${data.length})`}
          description="Gestion d'organigramme "
        />
        <Button
          className="text-xs md:text-sm"
          onClick={() => router(`/admin-dashboard/organigramme-equipe/nouveau`)}
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
